import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Modal, Image, Button, Table, Tooltip, Tag, Switch } from "antd";
import moment from "moment";
import { EyeOutlined } from "@ant-design/icons";
import imageDefault from "../../../assets/images/placeholder.jpg";
import * as url from "../../../helpers/url_helper";
import { actionGroup, statusOptions } from "../../../helpers/common";
import { useTranslation } from "react-i18next";

const ModalInfomation = ({ showModal, handleClodeModal, infomationAction }) => {
  const { t } = useTranslation();
  const [beforeEffected, setBeforeEffected] = useState({});
  const [effectedItem, setEffectedItem] = useState({});
  const [isModalContentOpen, setIsModalContentOpen] = useState(false);
  const [titleModalContent, setTitleModalContent] = useState("");
  const [content, setContent] = useState("");
  const showModalContent = (content) => {
    setTitleModalContent(t("content"));
    setIsModalContentOpen(true);
    setContent(content);
  };

  const handleCancelModalContent = () => {
    setIsModalContentOpen(false);
  };
  useEffect(() => {
    if (showModal) {
      setBeforeEffected({ columns: [], listData: [] });
      setEffectedItem({ columns: [], listData: [] });
      switch (infomationAction.actionGroup) {
        case "company": {
          dataCompany(infomationAction);
          break;
        }
        case "department": {
          dataDepartment(infomationAction);
          break;
        }
        case "group": {
          dataGroup(infomationAction);
          break;
        }
        case "history": {
          dataHistory(infomationAction);
          break;
        }
        case "action": {
          dataAction(infomationAction);
          break;
        }
        case "user": {
          dataUser(infomationAction);
          break;
        }
        case "application": {
          dataApplication(infomationAction);
          break;
        }
        case "shift": {
          dataShift(infomationAction);
          break;
        }
        case "role": {
          dataRole(infomationAction);
          break;
        }
        default:
          break;
      }
    }
  }, [showModal]);
  const filterByActionGroup = (actionGroup, data) => {
    if (data && data.length > 0) {
      return data.filter((item) => item.actionGroup === actionGroup);
    } else return [];
  };
  const dataRole = (record) => {
    let columns = [
      {
        title: t("roleName"),
        dataIndex: "roleName",
      },
      {
        title: t("userAction"),
        dataIndex: "",
        width: "65%",
        render: (_, record) => {
          return (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              {actionGroup.map((item) => {
                if (filterByActionGroup(item.value, record.actions).length > 0)
                  return (
                    <div
                      key={item.value}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "50%",
                      }}
                    >
                      <p style={{ marginTop: "15px", marginBottom: 0 }}>
                        {item.label} :
                      </p>
                      {}
                      {filterByActionGroup(item.value, record.actions).map(
                        (action) => {
                          return (
                            <p style={{ margin: 0 }} key={action.actionName}>
                              {` - ${action.actionLabel}`}
                            </p>
                          );
                        }
                      )}
                    </div>
                  );
              })}
            </div>
          );
        },
      },
      {
        title: t("createdTime"),
        dataIndex: "createdTime",
      },
    ];
    if (record.beforeEffected) {
      const beforeEffected = record.beforeEffected.map((item, index) => {
        return {
          key: index,
          roleName: item.roleName,
          actions: item.actions.map((action) => JSON.parse(action)),
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });

      setBeforeEffected({ columns, listData: beforeEffected });
    }
    if (record.effectedItem) {
      const effectedItem = record.effectedItem.map((item, index) => {
        return {
          key: index,
          roleName: item.roleName,
          actions: item.actions.map((action) => JSON.parse(action)),
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });
      setEffectedItem({ columns, listData: effectedItem });
    }
  };

  const dataShift = (record) => {
    let columns = [
      {
        title: t("shiftAttendanceName"),
        dataIndex: "shiftName",
      },
      {
        title: t("company"),
        dataIndex: "companys",
        render: (_, record) => {
          return record.companys.map((company, index) => (
            <p key={index}>
              {company}{" "}
              {index < record.companys.length - 1 && (
                <span style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                  |
                </span>
              )}
            </p>
          ));
        },
      },
      {
        title: t("department"),
        dataIndex: "departments",
        render: (_, record) => {
          return record.departments.map((department, index) => (
            <p key={index}>
              {department}{" "}
              {index < record.departments.length - 1 && (
                <span style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                  |
                </span>
              )}
            </p>
          ));
        },
      },
      {
        title: t("group"),
        dataIndex: "groups",
        render: (_, record) => {
          return record.groups.map((group, index) => (
            <p className="mb-0" key={index}>
              {group}{" "}
              {index < record.groups.length - 1 && (
                <span style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                  |
                </span>
              )}
            </p>
          ));
        },
      },
      {
        title: t("attendanceTime"),
        dataIndex: "shiftMinute",
        render: (_) => {
          return _ ? (
            <span>
              {_} {t("minutes")}
            </span>
          ) : (
            ""
          );
        },
      },
      {
        title: t("createdTime"),
        dataIndex: "createdTime",
      },
    ];
    if (record.beforeEffected) {
      const beforeEffected = record.beforeEffected.map((item, index) => {
        return {
          key: index,
          shiftName: item.shiftName,
          shiftMinute: item.shiftMinute,
          groups: item.groups,
          departments: item.departments,
          companys: item.companys,
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });

      setBeforeEffected({ columns, listData: beforeEffected });
    }
    if (record.effectedItem) {
      const effectedItem = record.effectedItem.map((item, index) => {
        return {
          key: index,
          shiftName: item.shiftName,
          shiftMinute: item.shiftMinute,
          groups: item.groups,
          departments: item.departments,
          companys: item.companys,
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });
      setEffectedItem({ columns, listData: effectedItem });
    }
  };
  const dataUser = (record) => {
    let columns = [
      {
        title: t("image"),
        render: (_, record) => {
          return (
            <Image
              className="rounded-circle"
              height={60}
              width={60}
              preview={false}
              src={`${process.env.REACT_APP_API_URL}/uploads/images/${record.avatar}`}
              fallback={imageDefault}
            />
          );
        },
      },
      {
        title: t("username"),
        dataIndex: "username",
      },
      {
        title: t("fullName"),
        dataIndex: "fullName",
        key: "name",
      },
      {
        title: t("phone"),
        dataIndex: "phoneNumber",
      },
      {
        title: t("email"),
        dataIndex: "email",
        key: "email",
      },
      {
        title: t("company"),
        dataIndex: "companyName",
      },
      {
        title: t("department"),
        dataIndex: "departmentName",
      },
      {
        title: t("group"),
        dataIndex: "groupName",
      },
      {
        title: t("role"),
        dataIndex: "roleName",
      },
      {
        title: t("cv"),
        dataIndex: "cv",
        render: (cv, record) => {
          if (cv) {
            return (
              <a
                href={`${process.env.REACT_APP_API_URL}/uploads/cv/${cv}`}
                target="_blank"
                rel="noreferrer"
              >
                CV_{record.username}
              </a>
            );
          } else return "";
        },
      },
      {
        title: t("activeStatus"),
        dataIndex: "status",
        render: (_, record) => {
          return <Switch size="small" checked={record.status} />;
        },
      },
      {
        title: t("createdTime"),
        dataIndex: "createdTime",
      },
    ];
    if (record.beforeEffected) {
      const beforeEffected = record.beforeEffected.map((item, index) => {
        return {
          key: index,
          username: item.username,
          fullName: item.fullName,
          email: item.email,
          phoneNumber: item.phoneNumber,
          roleName: item?.roleName,
          companyName: item?.companyName,
          departmentName: item?.departmentName,
          groupName: item?.groupName,
          status: item.status,
          avatar: item.avatar,
          cv: item.cv,
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });
      setBeforeEffected({ columns, listData: beforeEffected });
    }

    if (record.effectedItem) {
      const effectedItem = record.effectedItem.map((item, index) => {
        return {
          key: index,
          username: item.username,
          fullName: item.fullName,
          email: item.email,
          phoneNumber: item.phoneNumber,
          roleName: item?.roleName,
          companyName: item?.companyName,
          departmentName: item?.departmentName,
          groupName: item?.groupName,
          status: item.status,
          avatar: item.avatar,
          cv: item.cv,
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });
      setEffectedItem({ columns, listData: effectedItem });
    }
  };

  const getStatusString = (status) => {
    const statusObject = statusOptions.find(
      (option) => option.value === status
    );
    return statusObject
      ? { label: statusObject.label, color: statusObject.color }
      : { label: "", color: "" };
  };
  const dataApplication = (record) => {
    let columns = [
      {
        title: t("applyName"),
        dataIndex: "username",
      },
      {
        title: t("company"),
        dataIndex: "companyName",
      },
      {
        title: t("department"),
        dataIndex: "departmentName",
      },
      {
        title: t("applyStatus"),
        dataIndex: "status",
        render: (_, record) => {
          const obj = getStatusString(record.status);
          const previousObject = getStatusString(record.status - 1);
          const isOnBoard = record?.status === 3 ? true : false;
          return (
            <>
              {!isOnBoard ? (
                <Tag color={obj.color} style={{ borderRadius: 5 }}>
                  {obj.label}
                </Tag>
              ) : (
                <>
                  <Tag color={previousObject.color} style={{ borderRadius: 5 }}>
                    {previousObject.label}
                  </Tag>
                  <Tag color={obj.color} style={{ borderRadius: 5 }}>
                    {obj.label}
                  </Tag>
                </>
              )}
            </>
          );
        },
      },
      {
        title: t("createdTime"),
        dataIndex: "createdTime",
      },
    ];
    if (record.beforeEffected) {
      const beforeEffected = record.beforeEffected.map((item, index) => {
        return {
          key: index,
          username: item.createdBy,
          companyName: item?.companyName,
          departmentName: item?.departmentName,
          status: item.status,
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });
      setBeforeEffected({ columns, listData: beforeEffected });
    }
    if (record.effectedItem) {
      const effectedItem = record.effectedItem.map((item, index) => {
        return {
          key: index,
          username: item.createdBy,
          companyName: item?.companyName,
          departmentName: item?.departmentName,
          status: item.status,
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });
      setEffectedItem({ columns, listData: effectedItem });
    }
  };
  const dataAction = (record) => {
    let columns = [
      {
        title: t("actionName"),
        dataIndex: "actionName",
      },
      {
        title: t("actionLabel"),
        dataIndex: "actionLabel",
      },
      {
        title: t("actionGroup"),
        render: (_, record) => {
          const item = actionGroup.find(
            (item) => item.value === record.actionGroup
          );
          const label = item ? item.label : "";
          return <p>{label}</p>;
        },
      },
      {
        title: t("createdTime"),
        dataIndex: "createdTime",
      },
    ];
    if (record.beforeEffected) {
      const beforeEffected = record.beforeEffected.map((item, index) => {
        return {
          key: index,
          createdBy: item.createdBy,
          actionName: item.actionName,
          actionLabel: item.actionLabel,
          actionGroup: item.actionGroup,
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });

      setBeforeEffected({ columns, listData: beforeEffected });
    }
    if (record.effectedItem) {
      const effectedItem = record.effectedItem.map((item, index) => {
        return {
          key: index,
          createdBy: item.createdBy,
          actionName: item.actionName,
          actionLabel: item.actionLabel,
          actionGroup: item.actionGroup,
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });
      setEffectedItem({ columns, listData: effectedItem });
    }
  };
  const dataHistory = (record) => {
    let columns = [
      {
        title: t("userLogin"),
        dataIndex: "createdBy",
      },
      {
        title: "IP",
        dataIndex: "ip",
      },
      {
        title: "FP",
        dataIndex: "fp",
      },
      {
        title: t("createdTime"),
        dataIndex: "createdTime",
      },
    ];

    if (record.beforeEffected) {
      const beforeEffected = record.beforeEffected.map((item, index) => {
        return {
          key: index,
          createdBy: item.createdBy,
          ip: item.ip,
          fp: item.fp,
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });

      setBeforeEffected({ columns, listData: beforeEffected });
    }

    if (record.effectedItem) {
      const effectedItem = record.effectedItem.map((item, index) => {
        return {
          key: index,
          createdBy: item.createdBy,
          ip: item.ip,
          fp: item.fp,
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });
      setEffectedItem({ columns, listData: effectedItem });
    }
  };

  const dataGroup = (record) => {
    let columns = [
      {
        title: t("companyName"),
        dataIndex: "companyName",
      },
      {
        title: t("departmentName"),
        dataIndex: "departmentName",
      },
      {
        title: t("groupName"),
        dataIndex: "groupName",
      },
      {
        title: t("createdTime"),
        dataIndex: "createdTime",
      },
    ];

    if (record.beforeEffected) {
      const beforeEffected = record.beforeEffected.map((item) => {
        return {
          key: item.groupName,
          companyName: item.companyName,
          departmentName: item.departmentName,
          groupName: item.groupName,
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });
      setBeforeEffected({ columns, listData: beforeEffected });
    }

    if (record.effectedItem) {
      const effectedItem = record.effectedItem.map((item) => {
        return {
          key: item.groupName,
          companyName: item.companyName,
          departmentName: item.departmentName,
          groupName: item.groupName,
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });
      setEffectedItem({ columns, listData: effectedItem });
    }
  };

  const dataDepartment = (record) => {
    let columns = [
      {
        title: t("companyName"),
        dataIndex: "companyName",
      },
      {
        title: t("department"),
        dataIndex: "departmentName",
      },
      {
        title: t("group"),
        render: (_, record) => {
          return (
            record.groups &&
            record.groups.map((item, index) => (
              <p
                key={index}
                className="mb-0"
                style={{ display: "inline-block" }}
              >
                {item}
                {index < record.groups.length - 1 && (
                  <span style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                    |
                  </span>
                )}
              </p>
            ))
          );
        },
      },
      {
        title: t("logo"),
        render: (_, record) => {
          var image_avatart = imageDefault;
          if (_) image_avatart = _;
          return (
            <Image
              height={60}
              width={60}
              preview={false}
              src={`${process.env.REACT_APP_API_URL}${url.API_IMAGE_GET_BY_ID}/${record.companyLogo}`}
              fallback={imageDefault}
            />
          );
        },
      },
      {
        title: t("createdTime"),
        dataIndex: "createdTime",
      },
      {
        title: t("content"),
        dataIndex: "description",
        render: (description) => (
          <Tooltip title={t("viewContent")}>
            <Button
              type="default"
              shape="circle"
              icon={<EyeOutlined />}
              size="small"
              onClick={() => showModalContent(description)}
            />
          </Tooltip>
        ),
      },
    ];
    if (record.beforeEffected) {
      const beforeEffectedData = record.beforeEffected.map((item) => {
        return {
          key: item.departmentName,
          description: item.description,
          departmentName: item.departmentName,
          departmentLogo: item.departmentLogo,
          companyName: item.companyName,
          groups: item.groups,
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });
      setBeforeEffected({ columns, listData: beforeEffectedData });
    }
    if (record.effectedItem) {
      const effectedItem = record.effectedItem.map((item) => {
        return {
          key: item.departmentName,
          description: item.description,
          departmentName: item.departmentName,
          departmentLogo: item.departmentLogo,
          companyName: item.companyName,
          groups: item.groups,
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });

      setEffectedItem({ columns, listData: effectedItem });
    }
  };
  const dataCompany = (record) => {
    let columns = [
      {
        title: t("logo"),
        render: (_, record) => {
          var image_avatart = imageDefault;
          if (_) image_avatart = _;
          return (
            <Image
              height={60}
              width={60}
              preview={false}
              src={`${process.env.REACT_APP_API_URL}${url.API_IMAGE_GET_BY_ID}/${record.companyLogo}`}
              fallback={imageDefault}
            />
          );
        },
      },
      {
        title: t("companyName"),
        dataIndex: "companyName",
      },
      {
        title: t("department"),
        render: (_, record) => {
          return record.departments.map((item, index) => (
            <p key={index} className="mb-0" style={{ display: "inline-block" }}>
              {item}
              {index < record.departments.length - 1 && (
                <span style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                  |
                </span>
              )}
            </p>
          ));
        },
      },
      {
        title: t("createdTime"),
        dataIndex: "createdTime",
      },
    ];
    if (record.beforeEffected) {
      const beforeEffected = record.beforeEffected.map((item) => {
        return {
          key: item.companyName,
          companyName: item.companyName,
          companyLogo: item.companyLogo,
          departments: item.departments,
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });
      setBeforeEffected({ columns, listData: beforeEffected });
    }
    if (record.effectedItem) {
      const effectedItem = record.effectedItem.map((item) => {
        return {
          key: item.companyName,
          companyName: item.companyName,
          companyLogo: item.companyLogo,
          departments: item.departments,
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });
      setEffectedItem({ columns, listData: effectedItem });
    }
  };
  return (
    <>
      <Modal
        key={"infomation"}
        forceRender={true}
        title={t("infomationDescription")}
        width={1000}
        open={showModal}
        toggle={handleClodeModal}
        onCancel={handleClodeModal}
        footer={null}
        bodyStyle={{ overflowY: "auto", maxHeight: "calc(100vh - 200px)" }}
      >
        {infomationAction.beforeEffected && (
          <>
            <h4 className="text-center">
              {t("resultBefore")} {infomationAction.actionLabel.toLowerCase()}
            </h4>
            <Table
              rowKey="key"
              columns={beforeEffected.columns}
              dataSource={beforeEffected.listData}
              pagination={false}
            />
          </>
        )}
        {infomationAction.effectedItem && (
          <>
            <h4
              className={
                "text-center " + (infomationAction.beforeEffected ? "mt-4" : "")
              }
            >
              {t("resultAfter")} {infomationAction.actionLabel.toLowerCase()}
            </h4>
            <Table
              rowKey="key"
              columns={effectedItem.columns}
              dataSource={effectedItem.listData}
              pagination={false}
            />
          </>
        )}
      </Modal>

      <Modal
        centered
        title={titleModalContent}
        open={isModalContentOpen}
        footer={null}
        onCancel={handleCancelModalContent}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: content,
          }}
        />
      </Modal>
    </>
  );
};

ModalInfomation.propTypes = {
  handleClodeModal: PropTypes.func,
  showModal: PropTypes.bool,
  infomationAction: PropTypes.any,
};
export default ModalInfomation;
